<template>
  <div class="ov-page">
    <div class="ov-header">
      <div>
        <div class="ov-header__title">{{ $t('luggage.luggageManagement') }}</div>
        <p class="ov-header__subtitle">{{ $t('luggage.manageLuggage') }}</p>
      </div>
      <div class="ov-header__actions">
        <span class="ov-badge ov-badge--plain" :class="typeStrategieCompagnieStrategie ? 'ov-badge--success' : 'ov-badge--neutral'">
          <v-icon x-small>mdi-bag-suitcase-outline</v-icon>
          {{ strategyLabel }}
        </span>
        <span class="ov-badge ov-badge--navy ov-badge--plain">
          <v-icon x-small>mdi-ticket-confirmation-outline</v-icon>
          {{
            billetReservation && billetReservation.designation
              ? billetReservation.designation
              : $t('luggage.ticketSelected')
          }}
        </span>
        <button type="button" class="ov-btn ov-btn--secondary" @click="$router.push({ path: '/SearchTicket' })">
          <v-icon small>mdi-arrow-left</v-icon>
          Retour
        </button>
      </div>
    </div>

    <div class="ov-stack gb-stack">
      <!-- ===== INFORMATIONS GÉNÉRALES ===== -->
      <div class="ov-card">
        <div class="ov-card__head">
          <div class="ov-card__title">
            <v-icon small color="#159e72">mdi-account-outline</v-icon>
            {{ $t('luggage.generalInfo') }}
          </div>
        </div>
        <div class="ov-card__body">
          <div class="ov-row gb-info">
            <div class="gb-info__item">
              <div class="gb-info__label">{{ $t('luggage.name') }}</div>
              <div class="gb-info__value">
                {{ (billetReservation.clientDetails && billetReservation.clientDetails.nom) || '—' }}
              </div>
            </div>
            <div class="gb-info__item">
              <div class="gb-info__label">{{ $t('luggage.firstNames') }}</div>
              <div class="gb-info__value">
                {{ (billetReservation.clientDetails && billetReservation.clientDetails.prenoms) || '—' }}
              </div>
            </div>
            <div class="gb-info__item ov-col-full">
              <div class="gb-info__label"><v-icon x-small>mdi-email-outline</v-icon>{{ $t('luggage.email') }}</div>
              <div class="gb-info__value">
                {{ (billetReservation.clientDetails && billetReservation.clientDetails.email) || '—' }}
              </div>
            </div>
            <div class="gb-info__item">
              <div class="gb-info__label"><v-icon x-small>mdi-phone-outline</v-icon>{{ $t('luggage.phone') }}</div>
              <div class="gb-info__value">
                {{ (billetReservation.clientDetails && billetReservation.clientDetails.telephone) || '—' }}
              </div>
            </div>
            <div class="gb-info__item">
              <div class="gb-info__label"><v-icon x-small>mdi-map-marker-outline</v-icon>{{ $t('luggage.address') }}</div>
              <div class="gb-info__value">
                {{ (billetReservation.clientDetails && billetReservation.clientDetails.addresse) || '—' }}
              </div>
            </div>
          </div>

          <div class="ov-row gb-info gb-info--trip">
            <div class="gb-info__item">
              <div class="gb-info__label"><v-icon x-small>mdi-routes</v-icon>{{ $t('luggage.program') }}</div>
              <div class="gb-info__value">
                {{ (billetReservation && billetReservation.programmeDesignation) || '—' }}
              </div>
            </div>
            <div class="gb-info__item">
              <div class="gb-info__label">
                <v-icon x-small>mdi-clipboard-list-outline</v-icon>{{ $t('luggage.management.travelOffer') }}
              </div>
              <div class="gb-info__value">
                {{ (billetReservation && billetReservation.offreVoyageDesignation) || '—' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== ÉTIQUETAGE DES BAGAGES ===== -->
      <div class="ov-card">
        <div class="ov-card__head">
          <div class="ov-card__title">
            <v-icon small color="#159e72">mdi-tag-outline</v-icon>
            {{ $t('luggage.management.luggageLabeling') }}
          </div>
          <button type="button" class="ov-btn ov-btn--navy ov-btn--sm" @click="openDrawer">
            <v-icon small>mdi-plus</v-icon>
            {{ $t('luggage.management.addType') }}
          </button>
        </div>

        <div class="ov-card__body gb-form">
          <!-- Poids total (si stratégie par poids) -->
          <div class="ov-row" v-if="isWeightStrategy">
            <div class="ov-field">
              <label class="ov-label" for="gb-weight">
                {{ $t('luggage.management.totalWeight') }}<span class="ov-required">*</span>
              </label>
              <div class="ov-input-suffix">
                <input
                  id="gb-weight"
                  type="number"
                  class="ov-input"
                  v-model="bagageWeightObject.data.bagagePoidsDTO.poidsTotalBagage"
                  placeholder="0"
                />
                <span>kg</span>
              </div>
            </div>
          </div>

          <!-- Description -->
          <div class="ov-field">
            <label class="ov-label">{{ $t('luggage.management.description') }}</label>
            <textarea
              v-if="isWeightStrategy"
              v-model="bagageWeightObject.data.description"
              class="ov-textarea"
              rows="3"
              placeholder="Ajouter une description..."
            ></textarea>
            <textarea
              v-else-if="isTypeStrategy"
              v-model="bagageTypeObject.data.description"
              class="ov-textarea"
              rows="3"
              placeholder="Ajouter une description..."
            ></textarea>
            <textarea
              v-else
              class="ov-textarea"
              rows="3"
              disabled
              placeholder="Aucune stratégie définie"
            ></textarea>
          </div>

          <!-- Bagages enregistrés -->
          <div class="gb-bags">
            <div class="gb-bags__title">
              <v-icon small color="#159e72">mdi-bag-suitcase-outline</v-icon>
              {{ $t('luggage.management.registeredBags') }}
              <span class="ov-count">{{ bags.length }}</span>
            </div>
            <div v-if="bags.length == 0" class="ov-empty">
              {{ $t('luggage.management.noBagsRegistered') }}
            </div>
            <div v-else class="gb-bags__list">
              <div class="gb-bag" v-for="(item, index) in groupedBags" :key="index">
                <span class="gb-bag__num">{{ index + 1 }}</span>
                <span class="gb-bag__type">
                  <v-icon small>mdi-bag-suitcase-outline</v-icon>
                  {{ item.type }}
                </span>
                <span class="ov-badge ov-badge--navy ov-badge--plain">× {{ item.count }}</span>
                <button
                  type="button"
                  class="ov-icon-btn ov-icon-btn--danger"
                  title="Supprimer"
                  @click="deleteAllOfType(item.type)"
                >
                  <v-icon small>mdi-close</v-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="ov-card__foot">
          <button type="button" class="ov-btn ov-btn--secondary">
            {{ $t('luggage.management.reset') }}
          </button>
          <button type="button" class="ov-btn ov-btn--primary" @click="submitBag">
            <v-icon small>mdi-content-save-outline</v-icon>
            {{ $t('luggage.management.save') }}
          </button>
        </div>
      </div>

      <!-- ===== RÉSULTAT DE L'ENREGISTREMENT ===== -->
      <div v-if="apiResponse !== null">
        <DetailBagageClient
          v-if="isWeightStrategy"
          :response="apiResponse"
          :strategy-type="typeStrategieCompagnieStrategie"
        ></DetailBagageClient>

        <DetailBagageClientType
          v-else-if="isTypeStrategy"
          :response="apiResponse"
          :strategy-type="typeStrategieCompagnieStrategie"
        ></DetailBagageClientType>

        <div v-else class="ov-note ov-note--warning">
          <v-icon small color="#92400e">mdi-alert-outline</v-icon>
          <span>Aucune stratégie de bagage n'est définie pour cette compagnie.</span>
        </div>
      </div>
    </div>

    <!-- ===== PANNEAU : Ajouter un type de bagage ===== -->
    <v-navigation-drawer v-model="drawer" app temporary right width="400" class="ov-panel">
      <div class="ov-panel__head">
        <div class="ov-card__title">{{ $t('luggage.management.drawerTitle') }}</div>
        <button type="button" class="ov-icon-btn" @click="drawer = false">
          <v-icon small>mdi-close</v-icon>
        </button>
      </div>

      <div class="ov-panel__body">
        <!-- Sélection du type de bagage -->
        <div class="ov-field">
          <label class="ov-label">
            {{ $t('luggage.management.selectBagType') }}<span class="ov-required">*</span>
          </label>

          <!-- Liste pour stratégie par poids -->
          <div v-if="typeStrategieCompagnieStrategie === 'typeStrategieBagagePoids'" class="gb-choices">
            <button
              v-for="(sac, b) in referenceBagageTypeList"
              :key="b"
              type="button"
              class="gb-choice"
              :class="{ 'gb-choice--selected': typeBagageDesignation === sac.designation }"
              @click="typeBagageDesignation = sac.designation"
            >
              <v-icon small>mdi-bag-suitcase-outline</v-icon>
              <span class="gb-choice__text">{{ sac.designation }}</span>
              <v-icon v-if="typeBagageDesignation === sac.designation" small class="gb-choice__check">
                mdi-check-circle
              </v-icon>
            </button>
          </div>

          <!-- Liste pour stratégie par type -->
          <div v-else class="gb-choices">
            <div v-if="referenceBagageList.length === 0" class="ov-empty">Aucun type disponible</div>
            <button
              v-for="(sac, b) in referenceBagageList"
              :key="b"
              type="button"
              class="gb-choice"
              :class="{
                'gb-choice--selected': typeBagageDesignation === (sac.typeBagageDesignation || sac.designation),
              }"
              @click="typeBagageDesignation = sac.typeBagageDesignation || sac.designation"
            >
              <v-icon small>mdi-bag-suitcase-outline</v-icon>
              <span class="gb-choice__text">{{ sac.typeBagageDesignation || sac.designation }}</span>
              <v-icon
                v-if="typeBagageDesignation === (sac.typeBagageDesignation || sac.designation)"
                small
                class="gb-choice__check"
              >
                mdi-check-circle
              </v-icon>
            </button>
          </div>
        </div>

        <!-- Type sélectionné (aperçu) -->
        <div class="ov-field" v-if="typeBagageDesignation">
          <label class="ov-label">{{ $t('luggage.management.selectedType') }}</label>
          <span class="ov-badge ov-badge--success">{{ typeBagageDesignation }}</span>
        </div>
      </div>

      <div class="ov-panel__foot">
        <button type="button" class="ov-btn ov-btn--secondary" @click="drawer = false">
          {{ $t('luggage.management.cancel') }}
        </button>
        <button type="button" class="ov-btn ov-btn--primary" @click="addNewBag">
          <v-icon small>mdi-plus</v-icon>
          {{ $t('luggage.management.add') }}
        </button>
      </div>
    </v-navigation-drawer>

    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>
      {{ errorMsg }}
    </v-alert>
    <v-alert class="myalert alert-success" type="success" width="350px" dismissible>
      {{ successMsg }}
    </v-alert>
    <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
  </div>
</template>

<script>
import {
  API_GET_BAGAGE_TYPE_SELECTED,
  API_GET_STRATEGIE_PAR_COMPAGNIE,
  API_OBTENIR_REFERENCE_PAR_PAR_FAMILLE,
  API_SAVE_BAGAGE,
  HEADERS,
} from "@/components/globalConfig/globalConstConfig";
import axios from "axios";
import DetailBagageClient from "./widgets/DetailBagageClient.vue";
import DetailBagageClientType from "./widgets/DetailBagageClientType.vue";
import { showErrorMessage } from "@/modules/messages/messageProcess";

export default {
  name: "GestionBagagePoids",
  components: {
    DetailBagageClient,
    DetailBagageClientType,
  },

  data() {
    return {
      drawer: false,
      errorMsg: null,
      successMsg: null,
      overlay: false,

      strategieObject: {
        data: {
          compagnieTransportRaisonSociale: this.$store.state.userAuthentified.compagnieTransportRaisonSociale,
        },
      },

      typeStrategieCompagnieStrategie: null,
      typeBagageDesignation: null,

      // Renseigné avec strategieBagageTypeDTO.designation de la stratégie de la compagnie
      ObjectBagageByType: {
        data: {
          strategieBagageTypeDesignation: null,
        },
      },

      billetReservation: {},

      referenceBagageList: [],
      referenceBagageTypeList: [],

      referenceBagage: {
        referenceFamilleDesignation: "referenceFamilleBagage",
      },

      objectToSendReferenceBagage: {
        datas: [],
      },

      bags: [],

      bagageWeightObject: {
        data: {
          description: null,
          reservationBilletReference: null,
          bagagePoidsDTO: {
            poidsTotalBagage: null,
            typeBagages: [],
          },
        },
      },

      bagageTypeObject: {
        data: {
          reservationBilletReference: null,
          bagageTypeDTO: {
            typeBagages: [],
          },
        },
      },

      apiResponse: null,
    };
  },

  computed: {
    isWeightStrategy() {
      return this.typeStrategieCompagnieStrategie === "typeStrategieBagagePoids";
    },
    isTypeStrategy() {
      return this.typeStrategieCompagnieStrategie === "typeStrategieBagageType";
    },
    strategyLabel() {
      if (this.isWeightStrategy) return this.$t('luggage.management.strategyByWeight');
      if (this.isTypeStrategy) return this.$t('luggage.management.strategyByType');
      return this.$t('luggage.management.strategyUndefined');
    },
    // Grouper les bagages par type avec compteur
    groupedBags() {
      const grouped = {};
      this.bags.forEach(bag => {
        if (grouped[bag]) {
          grouped[bag]++;
        } else {
          grouped[bag] = 1;
        }
      });
      return Object.entries(grouped).map(([type, count]) => ({
        type,
        count
      }));
    },
  },

  methods: {
    // Ouvrir le drawer
    openDrawer() {
      this.drawer = true;
    },

    // Obtenir la strategie de gestion de bagage de la compagnie
    async getStrategyByCompany() {
      await axios
        .post(API_GET_STRATEGIE_PAR_COMPAGNIE, this.strategieObject, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          console.log("Afficher la strategie de la compagnie", response);
          if (response.status == 200) {
            if (response.data.status.code != 800) {
              this.typeStrategieCompagnieStrategie = null;
            } else {
              const strategie = response.data.item;
              this.typeStrategieCompagnieStrategie = strategie.typeStrategieBagageDesignation;

              // Stratégie par type : les types de bagages se récupèrent avec la désignation
              // réelle de la stratégie (ex. "STRATEGIE_BAGAGE_TYPE-261003-8NR3YKEWXJ")
              const strategieType = strategie.strategieBagageTypeDTO;
              this.ObjectBagageByType.data.strategieBagageTypeDesignation =
                strategieType && strategieType.designation ? strategieType.designation : null;
            }
          } else {
            this.errorMsg = "Erreur";
            showErrorMessage();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        });
    },

    // Save new bag submit
    async submitBag() {
      if (this.typeStrategieCompagnieStrategie == "typeStrategieBagagePoids") {
        if (
          this.bagageWeightObject.data.bagagePoidsDTO.poidsTotalBagage == null
        ) {
          this.errorMsg = this.$t('luggage.management.missingInfo');
          showErrorMessage();
        } else if (this.bags.length == 0) {
          this.errorMsg = this.$t('luggage.management.noBagSelected');
          showErrorMessage();
        } else {
          this.saveBagWithStrategy();
        }
      }

      if (this.typeStrategieCompagnieStrategie == "typeStrategieBagageType") {
        if (this.bags.length == 0) {
          this.errorMsg = this.$t('luggage.management.noBagSelected');
          showErrorMessage();
        } else {
          this.saveBagWithStrategy();
        }
      }
    },

    //Save new bag from API (Weight Strategy)
    async saveBagWithStrategy() {
      if (this.typeStrategieCompagnieStrategie == "typeStrategieBagagePoids") {
        this.bagageWeightObject.data.reservationBilletReference =
          this.$store.state.ticket.designation;
        this.bagageWeightObject.data.bagagePoidsDTO.typeBagages = this.bags;
      } else {
        this.bagageTypeObject.data.reservationBilletReference =
          this.$store.state.ticket.designation;
        this.bagageTypeObject.data.bagageTypeDTO.typeBagages = this.bags;
      }
      await axios
        .post(
          API_SAVE_BAGAGE,
          this.typeStrategieCompagnieStrategie == "typeStrategieBagagePoids"
            ? this.bagageWeightObject
            : this.bagageTypeObject,
          {
            headers: HEADERS(this.$store.state.userAuthentified.token),
          }
        )
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code != 800) {
              this.$swal.fire(
                "Opération non effectuée",
                response.data.status.message,
                "error"
              );
            } else {
              this.apiResponse = response.data.item;
              this.$swal
                .fire(
                  "Opération effectuée",
                  response.data.status.message,
                  "success"
                )
                .then((result) => {
                  if (result && result.isConfirmed) {
                    this.$router.push({ name: "SuiviDesBagages" }).catch(() => {});
                  }
                });
            }
          } else {
            this.$swal.fire(
              "Validation",
              "Error lors de la validation",
              "error"
            );
          }
        })
        .catch((e) => {
          this.$swal.fire("Opération non effectuée", e, "error");
        });
    },

    // ADD NEW BAG
    addNewBag() {
      if (this.typeBagageDesignation != null) {
        this.bags.push(this.typeBagageDesignation);
        // Réinitialiser la sélection
        this.typeBagageDesignation = null;
        // Fermer le drawer
        this.drawer = false;
      } else {
        this.errorMsg = this.$t('luggage.management.selectBagTypeError');
        showErrorMessage();
      }
    },

    //DELETE BAG SAVED
    deleteBag(position) {
      this.bags.splice(position, 1);
    },

    // DELETE ALL BAGS OF A SPECIFIC TYPE
    deleteAllOfType(type) {
      this.bags = this.bags.filter(bag => bag !== type);
    },

    // TO GET ALL TYPE BAGS
    async getReferenceBagageList() {
      // Sans désignation de stratégie par type, il n'y a pas de types de bagages à charger
      if (!this.ObjectBagageByType.data.strategieBagageTypeDesignation) {
        this.referenceBagageList = [];
        return;
      }
      await axios
        .post(API_GET_BAGAGE_TYPE_SELECTED, this.ObjectBagageByType, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          this.referenceBagageList = response.data?.items || [];
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
          this.referenceBagageList = [];
        });
    },

    //OBTENIR LA LISTE DES REFERENCES BAGAGES DISPONIBLE
    async obtenirReferenceTypeBagage() {
      this.objectToSendReferenceBagage.datas.push(this.referenceBagage);
      await axios
        .post(
          API_OBTENIR_REFERENCE_PAR_PAR_FAMILLE,
          this.objectToSendReferenceBagage,
          { headers: HEADERS(this.$store.state.userAuthentified.token) }
        )
        .then((response) => {
          console.log("Affichons la liste des types de bagage", response)
          this.referenceBagageTypeList = response.data?.items || [];
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
          this.referenceBagageTypeList = [];
        });
    },

    // INITIALIZE TICKET SELECTED
    initializeTicketFound() {
      this.billetReservation = this.$store.state.ticket;
    },
  },

  mounted() {
    this.initializeTicketFound();
    // La liste des types de bagages dépend de la stratégie : on l'attend avant de la charger
    this.getStrategyByCompany().then(() => this.getReferenceBagageList());
    this.obtenirReferenceTypeBagage();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/admin/ui";

.gb-stack {
  max-width: 1080px;
}

/* Informations du billet (lecture seule) */
.gb-info {
  row-gap: 18px;

  &--trip {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid $ov-line;
  }
}

.gb-info__item {
  min-width: 0;
}

.gb-info__label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: $ov-subtle;

  .v-icon {
    color: $ov-green !important;
  }
}

.gb-info__value {
  font-size: 15px;
  font-weight: 700;
  color: $ov-navy;
  word-break: break-word;
}

/* Formulaire d'étiquetage */
.gb-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.gb-bags {
  padding-top: 18px;
  border-top: 1px solid $ov-line;
}

.gb-bags__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 800;
  color: $ov-navy;
}

.gb-bags__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gb-bag {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid $ov-line;
  border-radius: 12px;
  background: $ov-soft;
}

.gb-bag__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 800;
  color: #ffffff;
  background: $ov-green;
  flex-shrink: 0;
}

.gb-bag__type {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 14px;
  font-weight: 700;
  color: $ov-ink;

  .v-icon {
    color: $ov-muted !important;
  }
}

/* Choix du type dans le panneau */
.gb-choices {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gb-choice {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 14px;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: $ov-ink;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;

  .v-icon {
    color: $ov-muted !important;
  }

  &:hover {
    border-color: rgba(21, 158, 114, 0.4);
  }

  &--selected {
    border-color: $ov-green;
    background: rgba(21, 158, 114, 0.06);

    .v-icon {
      color: $ov-green !important;
    }
  }
}

.gb-choice__text {
  flex: 1;
  min-width: 0;
}
</style>
